module.exports = __webpack_public_path__ + "img/00708e2.png";